import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class HodService {

  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) { }
  
  submitHodDetails(data) {
    return this.http.post(`${this.baseUrl}/submitHodDetails`, data);
  }

  getHodDetails() {
    return this.http.get(`${this.baseUrl}/getHodDetails`);
  }

  submitHodAttachment(data) {
    return this.http.post(`${this.baseUrl}/submitHodAttachment`, data);
  }

  getHodAttachment() {
    return this.http.get(`${this.baseUrl}/getHodAttachment`);
  }

  submitHodWorkingStatus(data) {
    return this.http.post(`${this.baseUrl}/submitHodWorkigStatus`, data);
  }

  getHodWorkingStatus() {
    return this.http.get(`${this.baseUrl}/getHodWorkingStatus`);
  }

  getState(token) {
    return this.http.get(`${this.baseUrl}/getState?token=` + token);
  }

  getDistrict(token, data) {
    return this.http.get(`${this.baseUrl}/getDistrict?token=${token}&state_id=` + data);
  }

  submitHodProfessionExperience(data) {
    return this.http.post(`${this.baseUrl}/submitHodProfessionExperience`, data);
  }

  getHodProfessionExperience() {
    return this.http.get(`${this.baseUrl}/getHodProfessionExperience`);
  }

  submitHodResearchExperience(data) {
    return this.http.post(`${this.baseUrl}/submitHodResearchExperience`, data);
  }

  getHodResearchExperience() {
    return this.http.get(`${this.baseUrl}/getHodResearchExperience`);
  }

  getHodRegDetails(data) {
    return this.http.get(`${this.baseUrl}/getHodRegDetails?email=` + data);
  }

  deleteHodProfessionDetails(data) {
    return this.http.get(`${this.baseUrl}/deleteHodProfessionalDetails?id=` + data);
  }

  deleteHodResearchDetails(data) {
    return this.http.get(`${this.baseUrl}/deleteHodResearchDetails?id=` + data);
  }
  
  submitedHodDetailsFinal() {
    return this.http.get(`${this.baseUrl}/submitedHodDetailsFinal`);
  }

  checkHodDetailsSubmitted() {
    return this.http.get(`${this.baseUrl}/checkHodDetailsSubmitted`);
  }

  getStudents() {
    return this.http.get(`${this.baseUrl}/getHodStudents`);
  }

  getAllHodMessages(data) {
    return this.http.get(`${this.baseUrl}/getAllHodMessages?role_id=`+data);
  }

  hodApplicationPrint() {
    return this.http.get(`${this.baseUrl}/hodApplicationPrint`);
  }
  getAppointmentType() {
    return this.http.get(`${this.baseUrl}/getAppointmentType`);
  }
  gethodDepartment() {
    return this.http.get(`${this.baseUrl}/gethodDepartment`);
  }

  getTopicsbyDepartment(department_id) {
    return this.http.get(`${this.baseUrl}/getTopicsbyDepartment?department_id=` + department_id);
  }

  getHodStudents() {
    return this.http.get(`${this.baseUrl}/getHodStudents`);
  }

  getHodStudentsByYear(data) {
    return this.http.get(`${this.baseUrl}/getHodStudentsByYear?current_year=` + data);
  }

  getHodSpecializations(){
    return this.http.get(`${this.baseUrl}/getHodSpecializations`)
  }

  getHodSpecializationsDropdDown() {
    return this.http.get(`${this.baseUrl}/getHodSpecializationsDropdDown`)
  }

  submitHodSpecializations(data) {
    return this.http.post(`${this.baseUrl}/submitHodSpecializations`, data);
  }
}
